import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Params, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import * as _ from 'lodash';
import { EnrichErrorType } from '../../models/error-type.enum';
import { AuthenticationService } from '../../resources/auth/authentication.service';

@Injectable()
export class LoggedInGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private location: Location,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authenticationService.authenticationInfo.map(authenticationInfo => {
      if (!_.isNull(authenticationInfo.user)) {
        return true;
      } else {
        let queryParams: Params = {};
        if (authenticationInfo.error && authenticationInfo.error.type === EnrichErrorType.CREDENTIALS_EXPIRED) {
          queryParams.error = 'CREDENTIALS_EXPIRED';
        }
        let path = state.url;
        queryParams.redirect = path.length ? path : undefined;
        this.router.navigate(['/login'], { queryParams });
        return false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/routing/logged-in.guard.ts